import { EnterAgentInformation } from "./EnterAgentInformation";
import { Notification } from "./Notification";
import { QuoteSaved } from "./QuoteSaved";

export const sharedPages = {
  EnterAgentInformation,
  Notification,
  QuoteSaved,
};
